module.exports = __webpack_public_path__ + "static/media/stay-woke.86aa7db6.png";